// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_1XC_c2jhMQ-p8DxAspG8dQ","close-btn":"_3Njzy6EYam3ApJMbn37Q5D"};